module.exports = __webpack_public_path__ + "static/media/ortobom-logo.bc187138.png";